<template lang="pug">
  thead.table_header(fill-height flat)
    tr
      th(rowspan="2") {{ $t('reservationPage.groupsLabel') }}
      th(v-for="(group, idx) in reservationData" :colspan="colspan(group.menuGroupSlot)" :key="idx") {{ group.menuGroup.name }}
      th(rowspan="2") {{ $t('reservationPage.stornoReservationLabel') }}
    tr
      th(v-for="(groupSlot, idx) in getSlots(reservationData)" :key="idx") {{ groupSlot.code }}

</template>

<script lang="ts">
import Vue from 'vue'
import DailyReservation from '@/model/reservation/DailyReservation'
import { CURRENT_RESERVATION_HEADER } from '@/store/getter-types'

export default Vue.extend({
  name: 'ReservationTableHeader',

  computed: {
    reservationData (): DailyReservation | undefined {
      return this.$store.getters[CURRENT_RESERVATION_HEADER]
    }
  },

  methods: {
    colspan (groupSlot: any): number {
      return groupSlot.length
    },

    getSlots (data: any): any[] {
      let slots: any[] = []

      if (data) {
        data.forEach((group: any) => {
          group.menuGroupSlot.forEach((slot: any) => {
            slots.push(slot)
          })
        })
      }

      return slots
    }
  },
})
</script>

<style lang="stylus" scoped>
  thead
    display: table-header-group;
    vertical-align: middle;
    border-color: inherit;
    border-bottom: 4px solid #333333;

    th
      border: 1px solid #c0c0c0;
      border-left: 1px solid #333333;
      padding: 3px 4px;

    th:first-child
      border-left: none;

    .normal
      font-weight normal
      font-size 0.8em
</style>
